const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})/;

/**
 * Renders an ISO date (or the date half of an ISO datetime) as the German `d.m.Y`
 * the backend templates use, and an empty string for anything it cannot read.
 *
 * The parsing is textual on purpose: `new Date('2024-03-01')` is UTC midnight, which
 * renders as the previous day for every viewer west of Greenwich.
 */
export function formatIsoDate(value: string | null | undefined): string {
    const match = ISO_DATE.exec(value ?? '');

    if (!match) {
        return '';
    }

    return `${match[3]}.${match[2]}.${match[1]}`;
}
